<h1 class="text-center mt-2">Gestion des opérations de {{concessionName}}</h1>
<div class="container-row top-field">
  <div class="btn1">
    <button (click)="SelectChangeHandlerCreer()" id="btn-add-concession" class="mr-5 btn btn-dark">
      <mat-icon>add_circle</mat-icon> Opération
    </button>
    <button (click)="massUpdate()" id="btn-add-concession" class="mr-5 mt-3 btn btn-dark">
      <mat-icon>edit</mat-icon> Modifier plusieurs opérations
    </button>
  </div>
  <div class="mt-5 mx-4 d-flex justify-content-between align-items-start">
  <div class="d-flex justify-content-between">
    <div class="d-flex">
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Active</mat-label>
        <mat-select [(ngModel)]="active" (selectionChange)="filterOperations()"  appearance="fill" multiple>
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Opération bloquante</mat-label>
        <mat-select [(ngModel)]="blocked" (selectionChange)="filterOperations()"  appearance="fill" multiple>
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="view-filter mr-2 w-auto" style="height: 45px">
        <mat-label>Attente autorisée</mat-label>
        <mat-select [(ngModel)]="waitingAuthorization" (selectionChange)="filterOperations()"  appearance="fill" multiple>
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width: 200px">
        <mat-label>Cherchez une opération</mat-label>
        <input [(ngModel)]="search" matInput (keyup)="applyFilter($event)">
      </mat-form-field>
    </div>
    <div class="ml-5">
      <fieldset class="mat-form-field mb-2">
        <legend class="font-weight-bold">Rappel configuration soft-planning</legend>
        <div>
          <div class="d-flex"><span class="font-weight-bold mr-1">Délai minimum :</span><span>{{softnetInfo?.Config.AppBehavior.FirstAppDays}}</span></div>
          <div class="d-flex"><span class="font-weight-bold mr-1">Jours autorisés :</span>
            <span *ngFor="let day of softnetInfo?.Config.AppBehavior.OnlyOnWeekdays.split(''); let index = index" class="mr-1">{{getDayOfTheWeek(day)}}</span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</div>
</div>

<div class="example-container">
  <table mat-table [dataSource]="dataSource" class="user-table mat-elevation-z8">

    <ng-container matColumnDef="checkbox">
<!--      <th mat-header-cell *matHeaderCellDef> <mat-checkbox #c (click)="changeSelectAllOperations(c.checked)"></mat-checkbox></th>-->
<!--      <td mat-cell *matCellDef="let element"> <mat-checkbox #c ch (click)="changeSelectedOperations(element, c.checked)"></mat-checkbox> </td>-->
      <!-- En-tête : checkbox "tout sélectionner" -->
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [aria-label]="checkboxLabel()"
          class="mt-3">
        </mat-checkbox>
      </mat-header-cell>

      <!-- Cellule : checkbox individuelle -->
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"
          class="mt-3">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sofNet_id">
      <th mat-header-cell *matHeaderCellDef> ID SOFT Net </th>
      <td mat-cell *matCellDef="let element"> {{element.sofNet_id}} </td>
    </ng-container>

    <ng-container matColumnDef="requiredStandartRangeService">
      <th mat-header-cell *matHeaderCellDef> Gamme standard </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.requiredStandartRangeService">check</mat-icon>
        <mat-icon *ngIf="!element.requiredStandartRangeService">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="bmw_id">
      <th mat-header-cell *matHeaderCellDef> ID BMW </th>
      <td mat-cell *matCellDef="let element"> {{element.bmw_id}} </td>
    </ng-container>

    <ng-container matColumnDef="categorie">
      <th mat-header-cell *matHeaderCellDef> Catégorie </th>
      <td mat-cell *matCellDef="let element"> {{element.categorie}} </td>
    </ng-container>

    <ng-container matColumnDef="nom">
      <th mat-header-cell *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let element"> {{element.nom}} </td>
    </ng-container>

    <ng-container matColumnDef="vt">
      <th mat-header-cell *matHeaderCellDef > Temps (VT) </th>
      <td mat-cell *matCellDef="let element"> {{element.vt}} </td>
    </ng-container>

    <ng-container matColumnDef="actif">
      <th mat-header-cell *matHeaderCellDef > Actif </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.actif">check</mat-icon>
        <mat-icon *ngIf="!element.actif">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="ordre">
      <th mat-header-cell *matHeaderCellDef > Ordre </th>
      <td mat-cell *matCellDef="let element"> {{element.ordre}} </td>
    </ng-container>

    <ng-container matColumnDef="blocked">
      <th mat-header-cell *matHeaderCellDef > Opération bloquante </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.blocked">check</mat-icon>
        <mat-icon *ngIf="!element.blocked">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="dynamicTest">
      <th mat-header-cell *matHeaderCellDef > Essai dynamique </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.dynamicTest">check</mat-icon>
        <mat-icon *ngIf="!element.dynamicTest">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="commentaireAdditionnel">
      <th mat-header-cell *matHeaderCellDef > Commentaire additionnel </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.commentaireAdditionnel">
<!--          {{element.commentaireAdditionnel}}-->
          <mat-icon (click)="onClickMessage(element.commentaireAdditionnel)" class="concession-icon pointer"> message</mat-icon>
        </div>
        <div *ngIf="!element.commentaireAdditionnel">-</div>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef > Type </th>
      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>aideAdditionnel

    <ng-container matColumnDef="attente_autorise">
      <th mat-header-cell *matHeaderCellDef > Attente autorisé </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.attente_autorise">check</mat-icon>
        <mat-icon *ngIf="!element.attente_autorise">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="aideAdditionnel">
      <th mat-header-cell *matHeaderCellDef > Aide additionnelle </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.aideAdditionnel">check</mat-icon>
        <mat-icon *ngIf="!element.aideAdditionnel">close</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="minimum_delay">
      <th mat-header-cell *matHeaderCellDef > Délai minimum </th>
      <td mat-cell *matCellDef="let element"> {{element.minimum_delay}} </td>
    </ng-container>

    <ng-container matColumnDef="modifier">
      <th mat-header-cell *matHeaderCellDef> Modifier </th>
      <td mat-cell *matCellDef="let element">
        <button class="m-2 btn btn-round-40 btn-dark" (click)="SelectChangeHandlerModifier(element.id)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
                 (click)="displayPaginatorAllOption()"
                 (page)="pageChange()"
                 showFirstLastButtons
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>
